export const STREET_MAX_LENGTH = 50;
export const NUMBER_MAX_LENGTH = 5;
export const NEIGHBORHOOD_MAX_LENGTH = 30;
export const CITY_MAX_LENGTH = 30;
export const COMPLEMENT_MAX_LENGTH = 30;
export const STATE_MAX_LENGTH = 2;
export const MISSING_CORREIOS_ADDRESS_REQUIRED_FIELD =
  'Campos obritatórios não preenchidos';
